import React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function FacebookResponse({ status, oauthCode, error }) {
  const navigate = useNavigate();

  const goToHome = () => navigate("/dashboard");

  const renderContent = () => {
    if (status === "success") {
      return (
        <>
          <MDTypography variant="h4" fontWeight="bold" gutterBottom color="success">
            Facebook Connected Successfully 🎉
          </MDTypography>

          <MDTypography variant="body1" mt={2}>
            Your Facebook Page is now linked to Comparedly.
          </MDTypography>

          <MDButton variant="gradient" color="success" sx={{ mt: 4 }} onClick={goToHome}>
            Go to Dashboard
          </MDButton>
        </>
      );
    }

    if (status === "cancelled") {
      return (
        <>
          <MDTypography variant="h4" fontWeight="bold" gutterBottom color="warning">
            Facebook Login Cancelled ⚠️
          </MDTypography>

          <MDTypography variant="body1" mt={2}>
            Facebook login was interrupted or cancelled.
          </MDTypography>

          <MDButton variant="gradient" color="warning" sx={{ mt: 4 }} onClick={goToHome}>
            Return to Dashboard
          </MDButton>
        </>
      );
    }

    if (error) {
      return (
        <>
          <MDTypography variant="h4" fontWeight="bold" gutterBottom color="error">
            Facebook Authentication Error ❌
          </MDTypography>

          <MDTypography variant="body2" mt={2}>
            Error: {error}
          </MDTypography>

          <MDButton variant="gradient" color="error" sx={{ mt: 4 }} onClick={goToHome}>
            Try Again
          </MDButton>
        </>
      );
    }

    return (
      <>
        <MDTypography variant="h4" fontWeight="bold" gutterBottom color="error">
          Facebook Connection Failed ❌
        </MDTypography>

        <MDTypography variant="body1" mt={2}>
          Unable to connect your Facebook account.
        </MDTypography>

        <MDButton variant="gradient" color="error" sx={{ mt: 4 }} onClick={goToHome}>
          Try Again
        </MDButton>
      </>
    );
  };

  return <MDBox textAlign="center">{renderContent()}</MDBox>;
}

export default FacebookResponse;
